import React, { useEffect, useState } from 'react';

const Loader = ({ isLoading }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [opacity, setOpacity] = useState(1);

  // Check if loader should be shown today
  const shouldShowLoader = () => {
    try {
      const lastShown = localStorage.getItem('loaderLastShown');
      const today = new Date().toDateString();
      
      if (!lastShown || lastShown !== today) {
        // Show loader and update localStorage
        localStorage.setItem('loaderLastShown', today);
        return true;
      }
      
      return false;
    } catch (error) {
      // If localStorage is not available, show loader
      console.log('localStorage not available, showing loader');
      return true;
    }
  };

  useEffect(() => {
    // Check if we should show the loader today
    if (shouldShowLoader()) {
      setShowLoader(true);
    } else {
      // Skip loader entirely if already shown today
      setShowLoader(false);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && showLoader) {
      setOpacity(0);
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 1200); // Duration of the fade-out animation
      return () => clearTimeout(timer);
    }
  }, [isLoading, showLoader]);

  if (!showLoader) return null;
  
  return (
    <div className="loader-container" style={{ opacity }}>
      <div className="loader-content">
        <div className="medical-loader">
          <div className="heartbeat-icon">
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <path className="heartbeat-line" d="M10,50 L30,50 L40,30 L50,70 L60,50 L70,50 L90,50" fill="none" stroke="#1977cc" strokeWidth="4" strokeLinecap="round"/>
              <circle className="pulse-circle" cx="50" cy="50" r="35" fill="none" stroke="#1977cc" strokeWidth="2" strokeOpacity="0.3"/>
            </svg>
          </div>
          <div className="loader-text">
            <h2>Ali Cranta Medical Center</h2>
            <p>Pregătim cabinetul pentru dumneavoastră...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader; 